<template>
	<v-modal>
		<template v-slot:header>
			<h1>Call Log</h1>
		</template>
		<table>
			<thead>
				<tr>
					<th align="left">Called</th>
					<th align="left">Duration</th>
					<th align="center">Status</th>
				</tr>
			</thead>
			<tfoot>
				<tr>
					<th align="left">Called</th>
					<th align="left">Duration</th>
					<th align="center">Status</th>
				</tr>
			</tfoot>
			<tbody>
				<tr v-for="(call, callIndex) in calls" :key="callIndex">
					<td align="left" v-html="$present('dateTime', call.created_at)"/>
					<td align="left" v-html="$present('duration', call.duration)"/>
					<td align="center">
						<status-badge :status="call.status" group="call"/>
					</td>
				</tr>
			</tbody>
		</table>
	</v-modal>
</template>
<script>

export default {
	props: {
		calls: {
			required: true,
			type: Array,
		},
	},
};
</script>
